module.exports = __webpack_public_path__ + "static/media/dumpster-fire.cb1e00cd.svg";